module.exports = __webpack_public_path__ + "static/rockshox-logo-3ae5e7393d3055a31c43ddeac3adda5a.png";